'use es6';

import { curry } from 'rich-text-lib/utils/iterables';
import { closest } from 'UIComponents/utils/Dom';
export const isHubSpotUI = curry(function isHubSpotUI(namespace, el) {
  if (!el || !el.nodeType === 1) {
    return false;
  }
  if (el.className.indexOf(namespace) > -1) {
    return true;
  }
  if (el.parentNode && el.parentNode.nodeType === 1) {
    return isHubSpotUI(namespace, el.parentNode);
  }
  return false;
});
export const isMceUI = el => {
  return closest(el, `[class*=mce-]`) !== null;
};